module.exports = __webpack_public_path__ + "static/media/Tutorial-Performance-Reports.7b660b09.pdf";